import View from './base';

import Model from '../models/base';

function zPad( number ) {
	return ( '00' + number ).substr( -2 );
}

export default View.extend( {
	elements: {
		$startInput: '.-start-input',
		$endInput: '.-end-input',
		$startDisplay: '.-start-display',
		$endDisplay: '.-end-display',
	},

	events: {
		'click .-hour': 'setHour',
		'click .-meridian': 'setMeridian',
		'click .-start-display,.-end-display': 'setMode',
		'input .-start-input': 'setStart',
		'input .-end-input': 'setEnd',
	},

	listeners: {
		'model change:start': 'renderStart',
		'model change:end': 'renderEnd',
	},

	initialize: function() {
		this.model = new Model( {
			start: 12,
			end: 12,
		} );

		this.mode = 'start';
		this.meridian = 'am';

		View.prototype.initialize.apply( this, arguments );
	},

	switchMode: function( mode ) {
		if ( ! mode ) {
			mode = this.mode === 'start' ? 'end' : 'start';
		}

		this.mode = mode;

		this.meridian = this.model.get( mode ) > 12 ? 'pm' : 'am';

		this.renderMode();
		this.renderMeridian();
	},

	_setHour: function( hour ) {
		hour = hour || this.model.get( this.mode );

		var pm = this.meridian === 'pm';

		if ( hour === 12 && ! pm ) {
			hour = 0;
		} else
		if ( hour < 12 && pm ) {
			hour += 12;
		} else
		if ( hour > 12 && ! pm ) {
			hour -= 12;
		}

		this.model.set( this.mode, hour );
	},

	setHour: function( e ) {
		var hour = parseInt( typeof e === 'object' ? e.currentTarget.value : e );

		this._setHour( hour );

		this.switchMode();
	},

	setMeridian: function( e ) {
		this.meridian = e.target.value;

		this._setHour();
		this.renderMeridian();
	},

	setMode: function( e ) {
		this.switchMode( e.target.name );
	},

	_setTime: function( type, value ) {
		var [ hour ] = value.split( ':' ).map( val => parseInt( val, 10 ) );

		this.model.set( type, hour );
	},

	setStart: function( e ) {
		this._setTime( 'start', e.currentTarget.value );
	},

	setEnd: function( e ) {
		this._setTime( 'end', e.currentTarget.value );
	},

	render: function() {
		this.renderStart();
		this.renderEnd();
		this.renderMeridian();
		this.renderMode();

		return this;
	},

	_renderTime: function( type ) {
		var hour = this.model.get( type );

		this[ `$${type}Input` ].val( `${zPad(hour)}:00` );
		this[ `$${type}Display` ].fill( `${zPad(hour)}:00` );

		if ( hour > 12 ) {
			hour -= 12;
		} else
		if ( hour <= 0 ) {
			hour = 12;
		}

		this.$el.attr( `data-${type}`, hour );
	},

	renderStart: function() {
		this._renderTime( 'start' );
	},

	renderEnd: function() {
		this._renderTime( 'end' );
	},

	renderMeridian: function() {
		this.$el.attr( 'data-meridian', this.meridian );
	},

	renderMode: function() {
		this.$el.attr( 'data-mode', this.mode );
	},
} );
